/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Natural logarithm of the probability density function (PDF) for an inverse gamma distribution.
*
* @module @stdlib/stats/base/dists/invgamma/logpdf
*
* @example
* import logpdf from '@stdlib/stats/base/dists/invgamma/logpdf';
*
* var y = logpdf( 2.0, 0.5, 1.0 );
* // returns ~-2.112
*
* var mylogPDF = logpdf.factory( 6.0, 7.0 );
* y = mylogPDF( 2.0 );
* // returns ~-1.464
*/

// MODULES //

import setReadOnly from '@stdlib/utils/define-nonenumerable-read-only-property';
import main from './main.js';
import factory from './factory.js';


// MAIN //

setReadOnly( main, 'factory', factory );


// EXPORTS //

export default main;
